{
	"title": "Attributi del carbonio catturato",
	"buttonTitle": "Cattura e stoccaggio del carbonio",
	"table": {
		"materialDescription": "Materiale",
		"quantity": "Quantità",
		"productGwpTotal": "GWP totale del prodotto",
		"bundledCarbonReductions": "Riduzioni di carbonio raggruppate",
		"remainingGwp": "GWP rimanente",
		"epdForPhysicalMaterial": "EPD per il materiale fisico",
		"carbonPlantName": "Brevik, Norway"
	},
	"declarationDetailsBanner": {
		"rightfulHolderText": "is the rightful holder of the reported carbon reductions."
	},
	"modal": {
		"title": "Cattura e stoccaggio del carbonio",
		"description": "La Carbon Capture and Storage (CCS) è una tecnologia in grado di catturare le emissioni di anidride carbonica (CO2) prodotte dal processo di calcinazione e dall’uso di combustibili durante il funzionamento del forno, impedendo alla CO2 di entrare nell’atmosfera e stoccandola permanentemente nel sottosuolo. La CO2 catturata dall’impianto di Heidelberg Materials a Brevik, in Norvegia, viene compressa e trasportata fino a un sito di stoccaggio sotto il Mare del Nord. L’impianto di Brevik catturerà 400.000 tonnellate di CO2 all’anno.",
		"showLink": "Scopri di più sul processo di cattura del carbonio",
		"buttonClose": "Chiudi"
	},
	"footnote": "1) Le riduzioni di carbonio compensano le fasi A1-A3 dell’inventario del ciclo di vita del cemento."
}
